var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.821 1.22c-.197-.14-.46.01-.46.262V3.5H4.697c-1.52 0-2.753 1.222-2.753 2.73v6.312c0 .162.132.291.296.291H4.01c.163 0 .295-.291.295-.291V6.816c0-.537.44-.973.981-.973h3.074v2.009c0 .25.263.4.46.261l4.658-3.185a.326.326 0 0 0 0-.523L8.821 1.22Z"
  })));
}
export default SvgCommonIconMap;